import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import { PROFILE_KEY } from '../store/user'
import store from '../store'

const isAdmin = tenant => {
  try {
    const data = JSON.parse(localStorage.getItem(PROFILE_KEY))
    return data && data[tenant] && data[tenant].isAdmin === true
  } catch {
    return false
  }
}

Vue.use(VueRouter)

const isAuthenticated = route => {
  try {
    const data = JSON.parse(localStorage.getItem(PROFILE_KEY))
    return data && data[route.params.tenant] && data[route.params.tenant].token
  } catch {
    return false
  }
}
Vue.prototype.$isAuthenticated = isAuthenticated

const guestRoutes = ['Login', 'ResetPassword']

const guestRedirect = (to, from, next) => {
  if (to.name === 'Root') {
    next()
  } else {
    if (!isAuthenticated(to) && !guestRoutes.includes(to.name)) {
      next({ name: 'Login', params: { tenant: to.params.tenant } })
    } else {
      next()
    }
  }
}

const authRedirect = (to, from, next) => {
  if (to.name === 'Root') {
    next()
  } else {
    if (isAuthenticated(to) && guestRoutes.includes(to.name)) {
      next({ name: 'Home', params: { tenant: to.params.tenant } })
    } else {
      next()
    }
  }
}

const loadProfile = (to, from, next) => {
  store.dispatch('user/loadProfile', to.params.tenant).then(() => {
    next()
  })
}

const routes = [
  {
    path: '/styleguides',
    name: 'Styleguides',
    component: () =>
      import(/* webpackChunkName: "styleguides" */ '../views/Styleguides.vue'),
  },
  {
    path: '/',
    name: 'Root',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
  },
  {
    path: '/:tenant',
    redirect: '/:tenant/folders',
    name: 'Home',
    // omponent: Home,
  },
  {
    path: '/:tenant/profile',
    name: 'Profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
  },
  {
    path: '/:tenant/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/:tenant/reset-password',
    name: 'ResetPassword',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/:tenant/logout',
    name: 'Logout',
    component: () =>
      import(/* webpackChunkName: "logout" */ '../views/Logout.vue'),
  },
  {
    path: '/:tenant/folders',
    component: () =>
      import(/* webpackChunkName: "folders" */ '../views/Folders.vue'),
    children: [
      {
        path: ':id?',
        name: 'Folders',
        component: () =>
          import(/* webpackChunkName: "subfolder" */ '../views/Subfolder.vue'),
      },
    ],
  },
  {
    path: '/:tenant/podcasts/:id',
    component: () =>
      import(/* webpackChunkName: "podcasts" */ '../views/Podcasts.vue'),
    children: [
      {
        path: '',
        name: 'PodcastsSectionRoot',
        redirect: to => ({
          name: 'PodcastsSection',
          params: {
            tenant: to.params.tenant,
            id: to.params.id,
            section: 'font',
          },
        }),
      },
      {
        path: ':section',
        name: 'PodcastsSection',
        component: () =>
          import(
            /* webpackChunkName: "podcasts-section" */ '../views/PodcastsSection.vue'
          ),
      },
    ],
  },
  {
    path: '/:tenant/podcasts/:id/:section',
    name: 'Podcasts',
    component: () =>
      import(/* webpackChunkName: "podcasts" */ '../views/Podcasts.vue'),
  },
  {
    path: '/:tenant/users',
    name: 'Users',
    component: () =>
      import(/* webpackChunkName: "users" */ '../views/Users.vue'),
    beforeEnter(to, from, next) {
      if (isAdmin(to.params.tenant)) {
        next()
      } else {
        next({ name: 'Home' })
      }
    },
  },
  {
    path: '/:tenant/users/new',
    name: 'NewUser',
    component: () =>
      import(/* webpackChunkName: "new-user" */ '../views/NewUser.vue'),
    beforeEnter(to, from, next) {
      if (isAdmin(to.params.tenant)) {
        next()
      } else {
        next({ name: 'Home' })
      }
    },
  },
  {
    path: '/:tenant/users/:id',
    name: 'EditUser',
    component: () =>
      import(/* webpackChunkName: "edit-user" */ '../views/EditUser.vue'),
    beforeEnter(to, from, next) {
      if (isAdmin(to.params.tenant)) {
        next()
      } else {
        next({ name: 'Home' })
      }
    },
  },
  {
    path: '/:tenant/settings',
    name: 'Settings',
    redirect: to => ({
      name: 'SettingsSeo',
      params: { key: 'seo', tenant: to.params.tenant },
    }),
  },
  {
    path: '/:tenant/settings/seo',
    name: 'SettingsSeo',
    props: { settingKey: 'seo', pageTitle: 'Seo' },
    component: () =>
      import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/:tenant/settings/analytics',
    name: 'SettingsAnalytics',
    props: { settingKey: 'analytics', pageTitle: 'Analytics' },
    component: () =>
      import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/:tenant/settings/social',
    name: 'SettingsShare',
    props: { settingKey: 'share', pageTitle: 'Opzioni di Condivisione' },
    component: () =>
      import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
  },
  {
    path: '/:tenant/preview/:id',
    name: 'Preview',
    component: () =>
      import(/* webpackChunkName: "preview" */ '../views/Preview.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(authRedirect)
router.beforeEach(guestRedirect)
router.beforeEach(loadProfile)

export default router
